<template>
  <div>
    <form class="form-box">
      <b-container class="container-box">
        <b-row class="no-gutters">
          <b-col>
            <h1 class="font-weight-bold header-main text-uppercase mb-3">
              {{ id == 0 ? "เพิ่ม" : "แก้ไข" }}{{ "สินค้า" }}
            </h1>
          </b-col>
        </b-row>

        <b-tabs content-class="mt-0" class="mt-2 product-tabs">
          <b-tab title="ข้อมูลสินค้า" :active="controlTab == 1">
            <ProductDetailPanel
              class=""
              :state="state"
              ref="productDetailPanel"
              v-on:onSetIsDisplaySaleChanelTab="onSetIsDisplaySaleChanelTab"
              v-on:onSetProductType="onSetProductType"
              @handleRoute="handleRoute"
            />
          </b-tab>

          <b-tab
            title="รูปภาพ"
            :disabled="isDisabled"
            :active="controlTab == 2"
            class=""
          >
            <ProductImagePanel :state="state" :productTypeId="productTypeId" @handleRoute="handleRoute" />
          </b-tab>

          <b-tab
            title="ช่องทางออนไลน์"
            :disabled="isDisabled"
            :active="controlTab == 3"
            class=""
            v-if="isDisplaySaleChanelTab"
          >
            <ProductMarketingPanel :state="state" @handleRoute="handleRoute" />
          </b-tab>

          <b-tab
            title="คลังสินค้า"
            :disabled="isDisabled"
            :active="controlTab == 4"
            class=""
          >
            <ProductInventoryPanel :state="state"/>
          </b-tab>
        </b-tabs>
      </b-container>
    </form>
  </div>
</template>
<script>
import ProductDetailPanel from "./components/product-detail/ProductDetailPanel.vue";
import ProductSimple from "@/assets/mockdata/product/ProductSimple.json";
import ProductImagePanel from "./components/product-image/ProductImagePanel.vue";
import ProductMarketingPanel from "./components/product-marketing/ProductMarketing.vue";
import ProductInventoryPanel from "./components/product-inventory/ProductInventory.vue";
export default {
  name: "ProductDetails",
  components: {
    ProductDetailPanel,
    ProductImagePanel,
    ProductMarketingPanel,
    ProductInventoryPanel,
    ProductSimple,
  },
  data() {
    return {
      id: this.$route.params.id,
      modalMessage: "",
      controlTab: isNaN(parseInt(this.$route.query.tab))
        ? 1
        : parseInt(this.$route.query.tab),
      state: {
        isLoading: false,
      },
      productJson: ProductSimple,
      isDisplaySaleChanelTab: false,
      productTypeId: 0,
    };
  },
  created() {},
  methods: {
    hasHistory () { return window.history.length > 2 },
    handleRoute(){  
      if(this.hasHistory()) this.$router.back()
      else this.$router.push({ path: `/product?brandID=${this.$route.query.brandID}` });
    },
    onSetIsDisplaySaleChanelTab(value) {
      return (this.isDisplaySaleChanelTab = value);
    },
    onSetProductType(value) {
      this.productTypeId = value;
    },
  },
  computed: {
    isDisabled() {
      return this.$route.params.id == 0;
    },
  },
};
</script>

<style scoped>
</style>
